import { isRef as E, toRef as R, shallowRef as y, watch as H, onMounted as z, onUnmounted as B } from "vue";
const s = "scroll", b = "_vueTrackRemoveListener", C = (e) => {
  let t = {};
  return typeof e == "string" ? t.selector = e : typeof e == "function" ? t.callback = e : typeof e == "object" && e !== null && (t = e), t;
}, f = (e, t, r) => {
  e.style.setProperty(t, r);
}, p = (e) => {
  const t = e ? document.querySelector(e) : window;
  return t || console.warn(`No element found for selector "${e}"`), t ?? window;
}, P = (e, t = {}, r = !0) => {
  const n = E(t) ? t : R(t), l = E(e) ? e : R(e), v = y({ top: 0, left: 0 }), w = y({ vertical: !1, horizontal: !1 });
  let o = p(n.value.selector);
  const c = () => {
    requestAnimationFrame(() => {
      const i = l.value;
      if (!i)
        return;
      const { top: a, left: u, width: x, height: N } = i.getBoundingClientRect() || {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      };
      let m = window.innerHeight, h = window.innerWidth;
      if (o !== window && o !== null) {
        const k = o.getBoundingClientRect();
        m = k.height, h = k.width;
      }
      const d = n.value.offset || 0, g = a + N + d > 0 && a + d < m, L = u + x + d > 0 && u + d < h;
      v.value = { top: a, left: u }, w.value = { vertical: g, horizontal: L }, f(i, "--vue-track-visible-y", String(Number(g))), f(i, "--vue-track-visible-x", String(Number(L))), f(i, "--vue-track-y", `${a}px`), f(i, "--vue-track-x", `${u}px`), n.value.callback && n.value.callback(v.value, w.value);
    });
  }, S = () => {
    c(), o.addEventListener(s, c);
  }, T = () => {
    o.removeEventListener(s, c);
  };
  return r && (H(n, ({ selector: i }) => {
    i && (o.removeEventListener(s, c), o = p(i), o.addEventListener(s, c));
  }), z(() => {
    o.addEventListener(s, c);
  }), B(() => {
    o.removeEventListener(s, c);
  })), {
    position: v,
    visibility: w,
    addListener: S,
    removeListener: T
  };
}, V = {
  mounted(e, t) {
    const r = C(t.value), { addListener: n, removeListener: l } = P(e, r, !1);
    e[b] = l, n();
  },
  unmounted(e) {
    var t;
    (t = e[b]) == null || t.call(e);
  }
}, $ = {
  install: (e, t) => {
    e.directive((t == null ? void 0 : t.name) || "track-scroll", {
      ...V,
      mounted(r, n) {
        const l = C(n.value);
        n.value = { ...t, ...l }, V.mounted(r, n);
      }
    });
  }
};
export {
  V as VueTrackDirective,
  $ as VueTrackPlugin,
  P as useVueTrack
};
